<template>
    <div class="__cursepreview mb-2">
        <div class="d-flex p-3 b-white rounded shadow-sm align-items-center">
            <i class="fas fa-briefcase font-blue mr-1"></i>
            <span class="font-blue font-weight-bold text-left">{{jobParent.titulo}}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'JobNavBar',
    props:{
        jobParent: Object
    },
    data() {
        return {

        }
    },
    created() {

},
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/components/JobNavBar.vue